var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-profile-thumbnail-wrapper"},[_c('img',{staticClass:"load-profile-thumbnail-image",attrs:{"src":_vm.getThumbnail}}),(!_vm.itemThumbnail && _vm.isLoading)?_c('div',{staticClass:"load-profile-thumbnail-loading-text"},[_vm._v("\n    Vorschau wird geladen\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }